import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import Store from './store/store';
Vue.use(Router)


const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    { path: '/',  redirect: 'dashboard'},
    { path: '/login', component: AuthLayout, children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "triciclo" */ './views/Login.vue')
        }
      ] },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: () => import(/* webpackChunkName: "triciclo" */ './views/Dashboard.vue')
        }
      ],
      meta: { requiresAuth: true },
    },
    {
      path: '/postAnalytics',
      name: 'postAnalytics',
      component: DashboardLayout,
      children: [
        {
          path: '/postAnalytics',
          name: 'Análise dos Posts',
          component: () => import(/* webpackChunkName: "triciclo" */ './views/PostAnalytics.vue')
        }
      ],
      meta: { requiresAuth: true },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Store.state.isAuthenticated || Store.state.accessToken === "") { // Ou use sua API de composição para verificar isso
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
